export const mockHajjPackages = [
  {
    id: 1,
    title: "Premium Hajj Package 2024",
    type: "hajj",
    duration: "21 days",
    price: 8500,
    originalPrice: 9500,
    discount: 10,
    image: "https://readdy.ai/api/search-image?query=beautiful%20view%20of%20Kaaba%20in%20Mecca%20with%20pilgrims%20performing%20Hajj%2C%20golden%20hour%20lighting%2C%20peaceful%20spiritual%20atmosphere%2C%20Islamic%20architecture%2C%20holy%20mosque%20courtyard%20filled%20with%20worshippers%20in%20white%20ihram&width=400&height=300&seq=101&orientation=landscape",
    accommodation: "5-star",
    location: "Mecca & Medina",
    features: ["5-star Hotels", "All Meals", "Visa Processing", "Group Guide", "Ziyarat Tours"],
    rating: 4.8,
    reviews: 245,
    includes: [
      "Round-trip flights from Kaduna",
      "5-star accommodation in Mecca (close to Haram)",
      "4-star accommodation in Medina",
      "All meals (breakfast, lunch, dinner)",
      "Visa processing and documentation",
      "Experienced religious guide",
      "Airport transfers",
      "Ziyarat tours to historical sites"
    ]
  },
  {
    id: 2,
    title: "Economy Umrah Package",
    type: "umrah",
    duration: "10 days",
    price: 2800,
    originalPrice: 3200,
    discount: 12,
    image: "https://readdy.ai/api/search-image?query=peaceful%20view%20of%20Prophets%20Mosque%20in%20Medina%20with%20green%20dome%2C%20pilgrims%20walking%20in%20courtyard%2C%20Islamic%20architecture%2C%20spiritual%20atmosphere%2C%20evening%20prayer%20time%20with%20soft%20lighting&width=400&height=300&seq=102&orientation=landscape",
    accommodation: "3-star",
    location: "Mecca & Medina",
    features: ["3-star Hotels", "Breakfast Included", "Group Transport", "Basic Guide"],
    rating: 4.3,
    reviews: 189,
    includes: [
      "Round-trip flights",
      "3-star accommodation",
      "Daily breakfast",
      "Shared transportation",
      "Visa assistance",
      "Group guidance"
    ]
  },
  {
    id: 3,
    title: "Luxury Umrah Experience",
    type: "umrah",
    duration: "14 days",
    price: 5500,
    originalPrice: 6200,
    discount: 11,
    image: "https://readdy.ai/api/search-image?query=luxurious%20hotel%20room%20view%20overlooking%20Kaaba%20in%20Mecca%2C%20elegant%20Islamic%20interior%20design%2C%20premium%20accommodation%2C%20spiritual%20view%20from%20window%2C%20modern%20amenities%20with%20traditional%20touches&width=400&height=300&seq=103&orientation=landscape",
    accommodation: "5-star",
    location: "Mecca & Medina",
    features: ["Luxury Hotels", "All Meals", "Private Transport", "Scholar Guide", "VIP Services"],
    rating: 4.9,
    reviews: 156,
    includes: [
      "Business class flights",
      "5-star luxury hotels",
      "All meals included",
      "Private transportation",
      "Religious scholar guide",
      "VIP Haram access",
      "Spa and wellness services"
    ]
  },
  {
    id: 4,
    title: "Family Hajj Package",
    type: "hajj",
    duration: "18 days",
    price: 7200,
    originalPrice: 8000,
    discount: 10,
    image: "https://readdy.ai/api/search-image?query=Muslim%20family%20in%20white%20ihram%20clothing%20walking%20together%20towards%20Kaaba%2C%20children%20and%20parents%2C%20peaceful%20pilgrimage%20scene%2C%20spiritual%20journey%2C%20Islamic%20holy%20site%2C%20family%20bonding%20during%20Hajj&width=400&height=300&seq=104&orientation=landscape",
    accommodation: "4-star",
    location: "Mecca & Medina",
    features: ["Family Rooms", "Child-Friendly", "All Meals", "Medical Support"],
    rating: 4.6,
    reviews: 203,
    includes: [
      "Family-friendly accommodation",
      "Connecting rooms available",
      "Child care services",
      "Medical support on-site",
      "Educational programs for children",
      "Family group activities"
    ]
  }
];

export const mockUmrahServices = [
  {
    id: 1,
    title: "Visa Processing Service",
    description: "Complete visa documentation and processing for Saudi Arabia",
    price: 150,
    duration: "5-7 business days",
    icon: "ri-passport-line"
  },
  {
    id: 2,
    title: "Travel Insurance",
    description: "Comprehensive travel and medical insurance coverage",
    price: 85,
    duration: "Full trip coverage",
    icon: "ri-shield-check-line"
  },
  {
    id: 3,
    title: "Ziyarat Tours",
    description: "Guided tours to historical Islamic sites",
    price: 120,
    duration: "Half day",
    icon: "ri-map-pin-line"
  },
  {
    id: 4,
    title: "Airport Transfer",
    description: "Private airport pickup and drop-off service",
    price: 45,
    duration: "One way",
    icon: "ri-car-line"
  }
];

export const mockHajjGuides = [
  {
    id: 1,
    name: "Sheikh Abdullah Rahman",
    title: "Senior Hajj Guide",
    experience: "15 years",
    languages: ["English", "Arabic", "Hausa"],
    specialization: "Hajj rituals and Islamic history",
    image: "https://readdy.ai/api/search-image?query=professional%20Islamic%20scholar%20and%20Hajj%20guide%2C%20middle-aged%20man%20with%20beard%20wearing%20traditional%20Islamic%20clothing%2C%20wise%20and%20knowledgeable%20appearance%2C%20spiritual%20leader%20portrait&width=200&height=200&seq=105&orientation=squarish",
    rating: 4.9,
    reviews: 324
  },
  {
    id: 2,
    name: "Ustadh Fatima Al-Zahra",
    title: "Women's Group Specialist",
    experience: "12 years",
    languages: ["English", "Arabic", "French"],
    specialization: "Women's Hajj guidance and support",
    image: "https://readdy.ai/api/search-image?query=professional%20female%20Islamic%20scholar%20and%20guide%20wearing%20hijab%2C%20knowledgeable%20and%20caring%20appearance%2C%20spiritual%20teacher%20portrait%2C%20womens%20religious%20education%20specialist&width=200&height=200&seq=106&orientation=squarish",
    rating: 4.8,
    reviews: 267
  }
];